"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icon_1 = require("../Icon");
var ListToggle = function (_a) {
    var isExpanded = _a.isExpanded, onClick = _a.onClick, testId = _a.testId;
    var _b = React.useState(isExpanded !== null && isExpanded !== void 0 ? isExpanded : false), expanded = _b[0], setExpanded = _b[1];
    var toggleState = function (expansionState) {
        setExpanded(!expansionState);
        onClick(!expansionState);
    };
    React.useEffect(function () {
        setExpanded(isExpanded);
    }, [isExpanded]);
    return (React.createElement("button", { type: "button", className: "u-borderNone u-padNone u-colorInfo", style: { backgroundColor: 'transparent' }, onClick: function () { return toggleState(expanded); }, "data-testid": testId }, expanded === true ? React.createElement(Icon_1.Icon, { name: "down" }) : React.createElement(Icon_1.Icon, { name: "right" })));
};
exports.default = ListToggle;
